<div
  class="search-panel"
  (dblclick)="$event.stopPropagation()"
  (wheel)="$event.stopPropagation()"
>
  <!-- Header -->
  <div class="flex items-center justify-between px-4 pt-3 pb-2">
    <span class="text-sm font-semibold text-gray-800">Zoeken</span>
    <button
      class="flex items-center justify-center size-6 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 cursor-pointer transition-colors"
      type="button"
      (click)="close.emit()"
      matTooltip="Sluiten"
    >
      <mat-icon class="text-base!">close</mat-icon>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tab-bar">
    <button
      class="tab-item"
      [class.active]="activeTab() === 'units'"
      (click)="setActiveTab('units')"
    >
      Units
    </button>
    @if (canReadDevices()) {
      <button
        class="tab-item"
        [class.active]="activeTab() === 'devices'"
        (click)="setActiveTab('devices')"
      >
        Apparaten
      </button>
    }
    @if (canReadClients()) {
      <button
        class="tab-item"
        [class.active]="activeTab() === 'clients'"
        (click)="setActiveTab('clients')"
      >
        Cliënten
      </button>
    }
  </div>

  <!-- Search input -->
  <div class="px-4 pb-3">
    <div class="relative">
      <mat-icon
        class="search-icon absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        >search</mat-icon
      >
      <input
        #searchInput
        class="w-full pl-9 pr-8 py-2 text-sm bg-gray-50 border border-gray-200 rounded-md outline-none focus:border-gray-400 transition-colors"
        type="text"
        [placeholder]="activeTab() === 'units' ? 'Zoek op naam...' : 'Zoek op naam of ID...'"
        [ngModel]="searchText()"
        (ngModelChange)="searchText.set($event)"
      />
      <div
        class="search-spinner absolute right-2.5 top-1/2 -translate-y-1/2"
        [class.visible]="showSpinner()"
      ></div>
    </div>
  </div>

  @if (activeTab() === 'units') {
    <!-- Quick filters -->
    <div class="px-4 pb-3">
      <span class="text-[0.675rem] font-medium text-gray-500 mb-1.5 block"
        >Ik zoek units met...</span
      >
      <div class="flex flex-wrap gap-1.5">
        <button
          class="quick-filter-chip"
          [class.active]="quickFilters().hasRobots"
          (click)="toggleQuickFilter('hasRobots')"
        >
          Robots
        </button>
        <button
          class="quick-filter-chip"
          [class.active]="quickFilters().hasUnusedRobots"
          (click)="toggleQuickFilter('hasUnusedRobots')"
        >
          Vrije robots
        </button>
        <button
          class="quick-filter-chip"
          [class.active]="quickFilters().hasClients"
          (click)="toggleQuickFilter('hasClients')"
        >
          Cliënten
        </button>
      </div>
    </div>

    <!-- Advanced filters (collapsible) -->
    <div class="px-4 pb-3">
      <button
        class="expand-button"
        type="button"
        (click)="advancedExpanded.set(!advancedExpanded())"
      >
        <mat-icon class="expand-chevron">
          {{ advancedExpanded() ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        Geavanceerd
      </button>

      @if (advancedExpanded()) {
        <div class="mt-2 flex flex-col gap-2">
          <!-- Robots (totaal) filter -->
          <div class="advanced-filter-row">
            <span class="advanced-filter-label">Robots (totaal)</span>
            <select
              class="advanced-filter-select"
              [ngModel]="advancedFilters().totalRobots.operator"
              (ngModelChange)="updateAdvancedOperator('totalRobots', $event)"
            >
              <option value="disabled">Uit</option>
              <option value="gt">Meer dan</option>
              <option value="eq">Gelijk aan</option>
              <option value="lt">Minder dan</option>
            </select>
            <input
              class="advanced-filter-input"
              type="number"
              min="0"
              [ngModel]="advancedFilters().totalRobots.value"
              (ngModelChange)="updateAdvancedValue('totalRobots', $event)"
              [disabled]="advancedFilters().totalRobots.operator === 'disabled'"
            />
          </div>

          <!-- Robots (vrij) filter -->
          <div class="advanced-filter-row">
            <span class="advanced-filter-label">Robots (vrij)</span>
            <select
              class="advanced-filter-select"
              [ngModel]="advancedFilters().robots.operator"
              (ngModelChange)="updateAdvancedOperator('robots', $event)"
            >
              <option value="disabled">Uit</option>
              <option value="gt">Meer dan</option>
              <option value="eq">Gelijk aan</option>
              <option value="lt">Minder dan</option>
            </select>
            <input
              class="advanced-filter-input"
              type="number"
              min="0"
              [ngModel]="advancedFilters().robots.value"
              (ngModelChange)="updateAdvancedValue('robots', $event)"
              [disabled]="advancedFilters().robots.operator === 'disabled'"
            />
          </div>

          <!-- Cliënten filter -->
          <div class="advanced-filter-row">
            <span class="advanced-filter-label">Cliënten</span>
            <select
              class="advanced-filter-select"
              [ngModel]="advancedFilters().clients.operator"
              (ngModelChange)="updateAdvancedOperator('clients', $event)"
            >
              <option value="disabled">Uit</option>
              <option value="gt">Meer dan</option>
              <option value="eq">Gelijk aan</option>
              <option value="lt">Minder dan</option>
            </select>
            <input
              class="advanced-filter-input"
              type="number"
              min="0"
              [ngModel]="advancedFilters().clients.value"
              (ngModelChange)="updateAdvancedValue('clients', $event)"
              [disabled]="advancedFilters().clients.operator === 'disabled'"
            />
          </div>

          <!-- Gebruikers filter -->
          <div class="advanced-filter-row">
            <span class="advanced-filter-label">Gebruikers</span>
            <select
              class="advanced-filter-select"
              [ngModel]="advancedFilters().users.operator"
              (ngModelChange)="updateAdvancedOperator('users', $event)"
            >
              <option value="disabled">Uit</option>
              <option value="gt">Meer dan</option>
              <option value="eq">Gelijk aan</option>
              <option value="lt">Minder dan</option>
            </select>
            <input
              class="advanced-filter-input"
              type="number"
              min="0"
              [ngModel]="advancedFilters().users.value"
              (ngModelChange)="updateAdvancedValue('users', $event)"
              [disabled]="advancedFilters().users.operator === 'disabled'"
            />
          </div>
        </div>
      }
    </div>
  }

  <!-- Results (fixed height, always visible) -->
  <div class="border-t border-gray-200 px-4 pt-3 pb-1">
    @switch (activeTab()) {
      @case ('units') {
        <div class="flex items-center justify-between mb-2 min-h-4">
          @if (isFilterActive()) {
            <span class="text-xs text-gray-500">
              {{ filteredUnits().length }} resultaten
            </span>
            <button
              class="text-xs text-gray-400 hover:text-gray-600 cursor-pointer transition-colors"
              type="button"
              (click)="clearAll()"
            >
              Wis filters
            </button>
          }
        </div>

        <div class="results-list">
          @if (!isFilterActive()) {
            <div class="results-empty">
              <mat-icon class="text-[1.25rem]! text-gray-300">filter_list</mat-icon>
              <span>Gebruik de zoekbalk of filters</span>
            </div>
          } @else if (filteredUnits().length === 0) {
            <div class="results-empty">
              <mat-icon class="text-[1.25rem]! text-gray-300">search_off</mat-icon>
              <span>Geen resultaten!</span>
            </div>
          } @else {
            @for (unit of filteredUnits(); track unit._id) {
              <button
                class="result-item"
                type="button"
                (click)="onFocusUnit(unit._id)"
              >
                <mat-icon class="result-icon text-gray-400">deployed_code</mat-icon>
                <div class="result-content">
                  <span class="result-title">{{ unit.name }}</span>
                </div>
                <button
                  class="result-navigate-btn"
                  type="button"
                  (click)="onNavigateToUnit($event, unit._id)"
                  matTooltip="Ga naar unit"
                  matTooltipPosition="left"
                >
                  <mat-icon class="result-arrow">login</mat-icon>
                </button>
              </button>
            }
          }
        </div>
      }

      @case ('devices') {
        <div class="flex items-center justify-between mb-2 min-h-4">
          @if (devices().length > 0) {
            <span class="text-xs text-gray-500">
              {{ devices().length }} van {{ totalDeviceCount() ?? '...' }} apparaten
            </span>
          } @else {
            <span class="text-xs text-gray-500">
              {{ totalDeviceCount() ?? '' }} apparaten beschikbaar
            </span>
          }
        </div>

        <div class="results-list">
          @if (!lastSearchedText()) {
            <div class="results-empty">
              <mat-icon class="text-[1.25rem]! text-gray-300">filter_list</mat-icon>
              <span>Zoek op naam of ID...</span>
            </div>
          } @else if (devices().length === 0) {
            <div class="results-empty">
              <mat-icon class="text-[1.25rem]! text-gray-300">search_off</mat-icon>
              <span>Geen apparaten gevonden</span>
            </div>
          } @else {
            @for (device of devices(); track device._id) {
              <button
                class="result-item"
                type="button"
                (click)="onFocusUnit(device.unitId)"
              >
                <mat-icon class="result-icon text-gray-400">devices</mat-icon>
                <div class="result-content">
                  <span class="result-title">{{ device.label || device.idAlias }}</span>
                  <span class="result-subtitle">{{ unitNameMap().get(device.unitId) ?? 'Onbekende unit' }}</span>
                </div>
                <button
                  class="result-navigate-btn"
                  type="button"
                  (click)="onNavigateToDevice($event, device)"
                  matTooltip="Ga naar apparaat"
                  matTooltipPosition="left"
                >
                  <mat-icon class="result-arrow">login</mat-icon>
                </button>
              </button>
            }
          }
        </div>
      }

      @case ('clients') {
        <div class="flex items-center justify-between mb-2 min-h-4">
          @if (clients().length > 0) {
            <span class="text-xs text-gray-500">
              {{ clients().length }} van {{ totalClientCount() ?? '...' }} cliënten
            </span>
          } @else {
            <span class="text-xs text-gray-500">
              {{ totalClientCount() ?? '' }} cliënten beschikbaar
            </span>
          }
        </div>

        <div class="results-list">
          @if (!lastSearchedText()) {
            <div class="results-empty">
              <mat-icon class="text-[1.25rem]! text-gray-300">filter_list</mat-icon>
              <span>Zoek op naam of ID...</span>
            </div>
          } @else if (clients().length === 0) {
            <div class="results-empty">
              <mat-icon class="text-[1.25rem]! text-gray-300">search_off</mat-icon>
              <span>Geen cliënten gevonden</span>
            </div>
          } @else {
            @for (client of clients(); track client._id) {
              <button
                class="result-item"
                type="button"
                (click)="onFocusUnit(client.unitId)"
              >
                <mat-icon class="result-icon text-gray-400">person</mat-icon>
                <div class="result-content">
                  <span class="result-title">{{ client.name }}</span>
                  <span class="result-subtitle">{{ unitNameMap().get(client.unitId) ?? 'Onbekende unit' }}</span>
                </div>
                <button
                  class="result-navigate-btn"
                  type="button"
                  (click)="onNavigateToClient($event, client)"
                  matTooltip="Ga naar cliënt"
                  matTooltipPosition="left"
                >
                  <mat-icon class="result-arrow">login</mat-icon>
                </button>
              </button>
            }
          }
        </div>
      }
    }
  </div>
</div>
